'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import StoredContentContainer from '../../containers/StoredContentContainer';
import { LearningContentContainer } from '../../features/learningContent';
import LessonInfoTabs from '../LessonPage/LessonInfoTabs';

const TrackPage = ({
  track,
  onAdvanceContent,
  lesson,
  contentId
}) => {
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    contentId: contentId,
    lessonId: lesson.get('id'),
    children: [/*#__PURE__*/_jsx(StoredContentContainer, {
      contentId: contentId,
      isParentGraded: lesson.get('graded'),
      lessonId: lesson.get('id'),
      lessonName: lesson.get('name'),
      onFinish: onAdvanceContent,
      trackId: track.get('id'),
      trackName: track.get('name')
    }), /*#__PURE__*/_jsx(LessonInfoTabs, {
      lesson: lesson
    })]
  });
};

TrackPage.propTypes = {
  contentId: PropTypes.string.isRequired,
  lesson: ImmutablePropTypes.map.isRequired,
  onAdvanceContent: PropTypes.func.isRequired,
  track: ImmutablePropTypes.map.isRequired
};
export default TrackPage;